/**
 * Tâche 1441 (Eric 2026-10-02) — Texte d'un message de messagerie, dans la
 * langue de l'écran.
 *
 * Certains messages sont ÉCRITS PAR LE SERVEUR — le rappel de vote (1426) et
 * le résultat d'un sondage clos (1441). Aucun dictionnaire du navigateur ne
 * peut les traduire : le serveur les livre donc en deux langues, `text` et
 * `text_en` (même motif que les étapes du pipeline en 1399).
 *
 * Source unique volontaire : les deux écrans de messagerie (canaux et
 * conversations) rendaient `msg.text` chacun de leur côté. En laisser un sur
 * `text` ferait réapparaître le français selon l'écran — c'est exactement le
 * défaut 1421.
 *
 * ⚠️ Le repli est le FRANÇAIS, jamais une chaîne vide : un message d'équipe
 * sans traduction doit rester lisible plutôt que disparaître.
 */
export function texteMessage(message, lang) {
  if (!message) return "";
  if (lang === "en" && message.text_en) return message.text_en;
  return message.text || "";
}
